import { Drawer, Typography, Divider, CircularProgress, Box, Button } from '@mui/material';
import dayjs from 'dayjs';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDayReservationList } from '@/hooks/useDayReservationList';
import DetailsAccordion from '@/components/VarausDetails/DetailsAccordion';
import { useToastError } from '@/hooks/useToastError';

const DaySheet = ({ open, onClose, day, onOpenVarausModal }) => {
  const { list, loading, error } = useDayReservationList(day);
  const { t } = useTranslation();
  useToastError(error, t('calendar.fetchError'));

  if (!day) return null;

  const formatted = dayjs(day.date).format('DD.MM.YYYY');
  const isToday = dayjs(day.date).isSame(dayjs(Date.now()), 'day');
  const isPast = dayjs(day.date).isBefore(dayjs(Date.now()), 'day');

  if (error) return null;

  return (
    <Drawer
      variant="temporary"
      anchor="bottom"
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            height: '75vh',
            maxHeight: '90vh',
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16,
            overflow: 'hidden',
            paddingBottom: '1em',
          },
        },
      }}
    >
      <div style={{ paddingTop: '1em', paddingBottom: '1em', display: 'flex', flexDirection: 'column', height: '100%' }}>
        <Typography variant="h6" sx={{ textAlign: 'center' }}>
          {formatted}
        </Typography>
        <Divider sx={{ mt: 1 }} />
        <div style={{ flex: 1, overflowY: 'auto' }}>
          {loading && (
            <Box sx={{ mt: 1, display: 'flex', justifyContent: 'center' }}>
              <CircularProgress />
            </Box>
          )}
          {list?.length === 0 && !loading && (
            <Box sx={{ mt: 1, display: 'flex', justifyContent: 'center' }}>
              <Typography sx={{ mt: 2 }}>
                {t('calendar.noReservations')}
              </Typography>
            </Box>
          )}
          {list?.map(item => (
            <DetailsAccordion key={item.id.varausId} data={item} showSiivous={isToday} />
          ))}
        </div>
      </div>
      {day.available && (
        <Button disabled={isPast} onClick={onOpenVarausModal} variant="contained" sx={{ ml: 2, mr: 2 }}>
          {t('calendar.reserve')}
        </Button>
      )}
    </Drawer>
  );
};

export default DaySheet;
